import {
  buildSerializer,
  buildDeserializer,
  SerializeMap,
} from "lib/serializerUtils";

const integrationBusinessBalancesAmountSerializeMap: SerializeMap<IntegrationBusinessBalanceAmount> =
  {
    Outstanding: "Outstanding",
    Overdue: "Overdue",
  };

const integrationBusinessBalancesSerializeMap: SerializeMap<IntegrationBusinessBalances> =
  {
    AccountsReceivable: integrationBusinessBalancesAmountSerializeMap,
    AccountsPayable: integrationBusinessBalancesAmountSerializeMap,
  };

const integrationBusinessPhoneSerializeMap: SerializeMap<IntegrationBusinessPhone> =
  {
    type: "type",
    phoneNumber: "phone_number",
  };

const integrationBusinessNameSerializeMap: SerializeMap<IntegrationBusinessName> =
  {
    type: "type",
    value: "value",
  };

const integrationBusinessContactSerializeMap: SerializeMap<IntegrationBusinessContact> =
  {
    emailAddress: "email_address",
    firstName: "first_name",
    lastName: "last_name",
    phone: "phone",
  };

const integrationBusinessAddressSerializeMap: SerializeMap<IntegrationBusinessAddress> =
  {
    addressee: "addressee",
    city: "city",
    country: "country",
    line1: "line_1",
    line2: "line_2",
    postCode: "post_code",
    state: "state",
    type: "type",
  };

export const integrationBusinessSerializeMap: SerializeMap<IntegrationBusiness> =
  {
    id: "id",
    abn: "abn",
    accountNumber: "account_number",
    addresses: integrationBusinessAddressSerializeMap,
    balances: integrationBusinessBalancesSerializeMap,
    bsb: "bsb",
    businessId: "business_id",
    emailAddress: "email_address",
    contacts: integrationBusinessContactSerializeMap,
    credentialsId: "credentials_id",
    created: "created",
    integrationId: "integration_id",
    integrationIdType: "integration_id_type",
    lastModified: "last_modified",
    lastSuccessfulPull: "last_successful_pull",
    name: "name",
    names: integrationBusinessNameSerializeMap,
    permissions: "permissions",
    phones: integrationBusinessPhoneSerializeMap,
    type: "type",
  };

const nestedObjectMap = {
  addresses: "addresses",
  balances: "balances",
  contacts: "contacts",
  names: "names",
  phones: "phones",
};

export const serializeIntegrationBusiness = buildSerializer(
  integrationBusinessSerializeMap,
  "integrationBusiness",
  nestedObjectMap,
);

export const deserializeIntegrationBusiness = buildDeserializer(
  integrationBusinessSerializeMap,
  "integrationBusiness",
  nestedObjectMap,
);

// While this interface is similar to IntegrationBusiness in state,
// it is different enough with its optional and nullable fields to be managed on its own
interface IntegrationBusinessCreate {
  abn?: string | null;
  bsb?: string | null;
  accountNumber?: string | null;
  addresses?: IntegrationBusinessAddress[];
  businessId: string;
  contacts?: IntegrationBusinessContact[] | null;
  emailAddress: string;
  names?: IntegrationBusinessName[];
  phones?: IntegrationBusinessPhone[] | null;
}

export const integrationBusinessCreateSerializeMap: SerializeMap<IntegrationBusinessCreate> =
  {
    abn: "abn",
    accountNumber: "account_number",
    addresses: integrationBusinessAddressSerializeMap,
    bsb: "bsb",
    businessId: "business_id",
    emailAddress: "email_address",
    names: integrationBusinessNameSerializeMap,
    phones: integrationBusinessPhoneSerializeMap,
  };

export const serializeIntegrationBusinessCreate = buildSerializer(
  integrationBusinessCreateSerializeMap,
  "integrationBusiness",
  nestedObjectMap,
);
